import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PaginationService } from 'ngx-pagination';
import { GlobalStateProviderService } from '../../services/global-state-provider.service';

interface DocItem {
  previewDoc: string;
  documentName: string;
  previewUrl: string;
  isCurrent: boolean;
}

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html'
})
export class DocumentPreviewComponent implements OnInit {
  @Input() serviceName: string = '';
  @Input() items: DocItem[] = [];
  documentName: string = '';
  maximize: boolean = false;
  currentPage = 1;
  currentItem: DocItem | null = null;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly http: HttpClient,
    public paginationService: PaginationService,
    public globalStateProviderService: GlobalStateProviderService
  ) {}

  ngOnInit(): void {
    this.items.forEach((item, idx) => {
      if (item.isCurrent) {
        this.currentItem = item;
        this.currentPage = idx + 1;
      }
      this.http
        .get(item.previewUrl, { responseType: 'blob' })
        .subscribe((result) => {
          item.previewDoc = URL.createObjectURL(result);
        });
    });
  }

  toggleMaximize(): void {
    this.maximize = !this.maximize;
  }

  onPageChange(pageNum: number) {
    this.currentPage = pageNum;
    this.currentItem = this.items[pageNum - 1];
  }
}
